import React from 'react';
import { useSelector } from 'react-redux';
import isUndefined from 'lodash/isUndefined';

import { TextTruncate, toCurrency } from '@crm-framework/utils';
import { useDictionary } from '@crm-framework/dictionaries';

import { getIsCryptoCrm } from '@crm-package/app';

import { abcFields } from './consts';

import { toFormattedABCCurrency } from '.';

interface ICurrencyProps {
  value: number;
  intlOptions?: Intl.NumberFormatOptions;
  withTitle?: boolean;
  options?: { abc: string; tradingPlatformId: number };
  field?: string;
  withCurrencyPostfix?: boolean;
}

export const Currency = React.memo<ICurrencyProps>(
  ({
    value,
    intlOptions,
    withTitle = false,
    options,
    field,
    withCurrencyPostfix = false,
  }) => {
    const isCryptoCrm = useSelector(getIsCryptoCrm);
    const currenciesDictionary = useDictionary('currencies');

    const isAbcField =
      (!field && options?.abc && options?.tradingPlatformId) ||
      abcFields.find((item) => item === field);

    const formatAbcField =
      isAbcField && options
        ? toFormattedABCCurrency(
            value,
            options.abc,
            options.tradingPlatformId,
            currenciesDictionary
          )
        : toCurrency(value, {
            ...intlOptions,
            maximumFractionDigits: 2,
          });

    const formattedCurrency = isCryptoCrm
      ? toCurrency(value, {
          ...intlOptions,
          maximumFractionDigits: 8,
        })
      : formatAbcField;

    return (
      <TextTruncate title={withTitle ? formattedCurrency : undefined}>
        {formattedCurrency} {withCurrencyPostfix && (options?.abc || '')}
      </TextTruncate>
    );
  }
);

export const renderCurrencyColumn = (
  value?: number,
  field?: string,
  options?: any
) =>
  !isUndefined(value) ? (
    <Currency withTitle value={value} options={options} field={field} />
  ) : (
    ''
  );
